var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdealLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.75A2.75 2.75 0 012.75 0H10a8 8 0 110 16H2.75A2.75 2.75 0 010 13.25V2.75z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.433 7.516a1.113 1.113 0 100-2.226 1.113 1.113 0 000 2.226zm.84 4.488a1.683 1.683 0 01-1.685-1.684V9.004a.845.845 0 111.69 0v3h-.005z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.75C1 1.784 1.784 1 2.75 1H10a7 7 0 110 14H2.75A1.75 1.75 0 011 13.25V2.75zM2.75 2a.75.75 0 00-.75.75v10.5c0 .414.336.75.75.75H10a6 6 0 000-12H2.75z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55 4.56V12h3.238c2.94 0 4.214-1.66 4.214-4.009C14.002 5.744 12.727 4 9.788 4H7.11a.562.562 0 00-.561.56z",
    fill: "#E60073"
  })));
}
export default __webpack_public_path__ + "5261d830ce74100be4967ceefa2a7e93.svg";
export { SvgIdealLogo as ReactComponent };